import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { rem } from 'polished'
import styled from 'styled-components'
import Pane from 'components/Common/Pane'
import Group from 'components/utils/Group'
import uuidV4 from 'lib/string/uuidV4Utils'
import BodyText from 'LuxKit/Typography/BodyText'
import BedbankMultiSameRoomRoomOption from 'components/OfferPage/Bedbank/MultiRoom/BedbankMultiSameRoomRoomOption'
import useOfferPageBedbankRates from 'components/OfferPage/hooks/useOfferPageBedbankRates'

const OptionsContainer = styled.div`
  padding: ${rem(12)} ${rem(20)};
  background-color: ${props => props.theme.palette.neutral.default.eight};
`
interface Props {
  packageView: App.BedbankOfferPackageView
  roomPosition: number
  checkInDate?: string
  checkOutDate?: string
}

function BedbankPackageOptionsModalTab(props: Props) {
  const intl = useIntl()
  const { packageView, roomPosition, checkInDate, checkOutDate } = props

  const { rates, isFlexCfmrBedbankPackagesEnabled } = useOfferPageBedbankRates(packageView.effectiveRates, checkInDate, checkOutDate)

  const roomListId = useMemo(() => uuidV4(),
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    [packageView])

  const rateListId = useMemo(() => uuidV4(),
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    [rates])

  return (
    <Pane background="neutral-six">
      <Group direction="vertical" gap={8}>
        {rates.length > 1 && (
          <OptionsContainer>
            <BodyText variant="small" colour="neutral-three">{intl.formatMessage(
              {
                id: 'yqrms5SrXKisXE2UmHgH',
                defaultMessage: '{count, plural, one {# package option} other {# package options}} available',
                description: 'Count of available package options for a bedbank room',
              },
              { count: rates.length },
            )}
            </BodyText>
          </OptionsContainer>
        )}
        {rates.map((rate, index) => <Pane key={rate.id}>
          <BedbankMultiSameRoomRoomOption
            key={rate.id}
            rate={rate}
            packageNumber={index + 1}
            packageView={packageView}
            isFlexCfmrBedbankPackagesEnabled={isFlexCfmrBedbankPackagesEnabled}
            roomPosition={roomPosition}
            roomListId={roomListId}
            rateListId={rateListId}
          />
        </Pane>)}
      </Group>
    </Pane>
  )
}

export default BedbankPackageOptionsModalTab
